import categories from './categories/routes'
import media from './media/routes'

const NewsLayout = () => import('./layouts/NewsLayout.vue')

const NewsIndex = () => import('./views/NewsIndex.vue')
const NewsCreate = () => import('./views/NewsCreate.vue')
const NewsEdit = () => import('./views/NewsEdit.vue')

export default [
  {
    path: 'news',
    name: 'news.index',
    component: NewsIndex
  },
  {
    path: 'news/create',
    name: 'news.create',
    component: NewsCreate
  },
  {
    path: 'news/:newsId(\\d+)',
    component: NewsLayout,
    children: [
      {
        path: '',
        name: 'news.edit',
        component: NewsEdit
      },
      ...media
    ]
  },
  ...categories
]
